import React, { FC, useMemo } from "react";
import UpFade from "components/front/motion/UpFade";
import styled from "styled-components";
import Popup from "components/front/layout/Popup";
import YoutubeFrame from "components/front/layout/YoutubeFrame";

export type Props = { opened: boolean; onClose: () => void };
const HometownTaxVideoPopup: FC<Props> = ({ opened, onClose }) => {
  const videoId = useMemo(() => (opened ? "PE4-EHK9FN0" : undefined), [opened]);
  return (
    <UpFade in={opened}>
      <StyledPopup opened={opened} onClose={onClose}>
        {videoId && <StyledYoutubeFrame id={videoId} />}
      </StyledPopup>
    </UpFade>
  );
};
export default HometownTaxVideoPopup;

const StyledPopup = styled(Popup)`
  @media screen and (min-width: 961px) {
    width: 960px;
    height: 540px;
  }
  @media screen and (max-width: 960px) {
    width: 100%;
    height: calc(9 / 16 * 100vw);
  }
`;
const StyledYoutubeFrame = styled(YoutubeFrame)`
  height: 100%;
`;
